import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import StatsItem from './StatsItem';
import { localizations } from '../../localization/localization';
import logoDarkSmall from '../../images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_unitspotter_02_322x84.png';
import logoDarkLarge from '../../images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_unitspotter_04_827x215.png';
import logoLightSmall from '../../images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_unitspotter_01_322x84.png';
import logoLightLarge from '../../images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_unitspotter_03_827x215.png';
import rgbLogoPdf from '../../images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_logo_rgb.pdf';
import allLogosPdf from '../../images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_logo_kooste.pdf';

const styles = (theme: Theme) => createStyles({
  mediaLogoInfoContainer: {
    padding: '2.6875em',
    paddingTop: '4.375em',
    paddingBottom: '2.375em',
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  mediaLogoInfoBox: {
    maxWidth: 448,
    padding: '2.0625em',
    paddingLeft: '4.25em',
    paddingRight: '4.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  mediaLogoInfoBoxMobile: {
    maxWidth: 448,
    padding: '2.0625em',
    paddingLeft: '0.25em',
    paddingRight: '0.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  mediaLogoBoxContainer: {
    justifyContent: 'flex-start',
    paddingLeft: '2.25em',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    }
  },
  link: {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  mediaLogoBox: {
    maxWidth: 448,
    paddingLeft: '0.25em',
    paddingRight: '2.25em',
    paddingTop: '6.25em',
  },
  mediaLogoLink: {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    paddingLeft: '2.25em',
  },
  mediaLogoLinkMobile: {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    paddingLeft: '0.25em',
  },
  imageBox: {
    width: 322,
    height: 84,
    paddingLeft: '1.25em',
  },
  imageBoxMobile: {
    width: 200,
    height: 52,
  },
});

const MediaLogoInfoContainer: React.SFC<WithStyles & { isMobile?: boolean; }> = ({
  classes, isMobile
}) => {
  return (
    <Grid item container direction="row" className={classes.mediaLogoInfoContainer}>
      <Grid item container direction="column" className={isMobile === false ? classes.mediaLogoInfoBox : classes.mediaLogoInfoBoxMobile}>
        <Grid item>{localizations.mediaPageView.logoLoading}</Grid>
        <Grid item>
          <p>{localizations.mediaPageView.logoLoadingParagraph01}</p>
          <p><a download="sovellustunnus_unitspotter_logo_rgb.pdf" className={classes.link} href={rgbLogoPdf}>{localizations.mediaPageView.logoLoadingRGBVersion}</a></p>
          <p><a download="sovellustunnus_unitspotter_logo_kooste.pdf" className={classes.link} href={allLogosPdf}>{localizations.mediaPageView.logoLoadingAllLogos}</a></p>
        </Grid>
      </Grid>
      <Grid item container direction="row" className={classes.mediaLogoBoxContainer}>
        <Grid item className={classes.mediaLogoBox}>
          <img src={logoDarkSmall} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} />
          <p><a download="sovellustunnus_unitspotter_unitspotter_02_322x84.png" className={isMobile === false ? classes.mediaLogoLink : classes.mediaLogoLinkMobile} href={logoDarkSmall}>{localizations.mediaPageView.logoLoadingSmallVersion}</a></p>
          <p><a download="sovellustunnus_unitspotter_unitspotter_04_827x215.png" className={isMobile === false ? classes.mediaLogoLink : classes.mediaLogoLinkMobile} href={logoDarkLarge}>{localizations.mediaPageView.logoLoadingLargeVersion}</a></p>
        </Grid>
        <Grid item className={classes.mediaLogoBox}>
          <img src={logoLightSmall} className={isMobile === false ? classes.imageBox : classes.imageBoxMobile} />
          <p><a download="sovellustunnus_unitspotter_unitspotter_01_322x84.png" className={isMobile === false ? classes.mediaLogoLink : classes.mediaLogoLinkMobile} href={logoLightSmall}>{localizations.mediaPageView.logoLoadingSmallVersion}</a></p>
          <p><a download="sovellustunnus_unitspotter_unitspotter_03_827x215.png" className={isMobile === false ? classes.mediaLogoLink : classes.mediaLogoLinkMobile} href={logoLightLarge}>{localizations.mediaPageView.logoLoadingLargeVersion}</a></p>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(MediaLogoInfoContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/MediaLogoInfoContainer.tsx